import React from "react";
import PropTypes from "prop-types";
import { Typography, Grid } from "@material-ui/core";
import { FiberManualRecord } from "@material-ui/icons";
import Modal from "../Modal";
import { translate as t } from "../../../../infrastructure/translate/localization";
import useStyles from "./styles";
import CobeeButton from "../../CobeeButton";

export default function BenefitPlanOnboardingModal({ callback }) {
  const {
    container,
    paragraphContainer,
    listIcon,
    listText,
    decorationBackground,
    horizontalPadding,
  } = useStyles();

  return (
    <Modal
      title={t("benefits-section.onboarding.what-is-a-benefit-plan")}
      horizontalPadding={3}
    >
      <Grid item xs={12} className={decorationBackground} />
      <Grid container item xs={12} className={container}>
        <Grid
          item
          container
          xs={12}
          className={`${paragraphContainer} ${horizontalPadding}`}
        >
          <Typography variant="body1">
            {t("common-messages.a")} <b>{t("benefits-section.benefit-plan")}</b>{" "}
            {t("benefits-section.onboarding.benefit-plan-1")}
          </Typography>
        </Grid>
        <Grid
          item
          container
          xs={12}
          className={`${paragraphContainer} ${horizontalPadding}`}
        >
          <Typography variant="body1">
            {t("benefits-section.onboarding.benefit-plan-2")}
          </Typography>
        </Grid>
        <Grid
          item
          container
          xs={12}
          className={`${paragraphContainer} ${horizontalPadding}`}
        >
          <FiberManualRecord className={listIcon} />

          <Typography variant="body1" className={listText}>
            <b>{t("benefits-section.onboarding.benefit-plan-list-1-title")}</b>{" "}
            {t("benefits-section.onboarding.benefit-plan-list-1-content")}
          </Typography>
        </Grid>
        <Grid
          item
          container
          xs={12}
          className={`${paragraphContainer} ${horizontalPadding}`}
        >
          <FiberManualRecord className={listIcon} />
          <Typography variant="body1" className={listText}>
            <b>{t("benefits-section.onboarding.benefit-plan-list-2-title")}</b>{" "}
            {t("benefits-section.onboarding.benefit-plan-list-2-content")}
          </Typography>
        </Grid>
        <Grid
          item
          container
          xs={12}
          className={`${paragraphContainer} ${horizontalPadding}`}
        >
          <FiberManualRecord className={listIcon} />
          <Typography variant="body1" className={listText}>
            <b>{t("benefits-section.onboarding.benefit-plan-list-3-title")}</b>{" "}
            {t("benefits-section.onboarding.benefit-plan-list-3-content")}
          </Typography>
        </Grid>
        <Grid
          item
          container
          xs={12}
          className={`${paragraphContainer} ${horizontalPadding}`}
        >
          <Typography variant="body1">
            {t("common-messages.you-may-create-as-many")}{" "}
            <b>{t("benefits-section.benefit-plans")}</b>{" "}
            {t("benefits-section.onboarding.benefit-plan-3")}
          </Typography>
        </Grid>
      </Grid>
      <Grid item xs={12} container justifyContent="center">
        <CobeeButton styleType="primary" onClick={callback}>
          {t("benefits-section.add-benefit-plan")}
        </CobeeButton>
      </Grid>
    </Modal>
  );
}

BenefitPlanOnboardingModal.defaultProps = {};

BenefitPlanOnboardingModal.propTypes = {
  callback: PropTypes.func.isRequired,
};
